export function isValid(value) {
  return value != null && value === value;
}
